module.exports = __webpack_public_path__ + "static/media/287.1b80d2a6.webp";